(function(){
  // Mostrar el bloque solo en productos cuyo handle empiece por "mesa"
  var shouldHide = true; // Por defecto ocultar

  var path = (window.location.pathname || '').toLowerCase();
  var ref = (document.referrer || '').toLowerCase();

  function extractProductHandle(url) {
    var m = url.match(/\/products\/([^\/]+)/i);
    return m && m[1] ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  // Obtener handle de producto desde la ruta actual o el referrer
  var productHandle = extractProductHandle(path) || extractProductHandle(ref);

  // Comprueba que el producto empiece por la palabra "mesa"
  var isProductMesa = !!(productHandle && /^mesa\b/i.test(productHandle));

  // Mostrar solo si cumple la condición
  shouldHide = !isProductMesa;

  if (shouldHide) {
    try {
      document.body.classList.add('hide-bottom-nosotros');
      document.documentElement.classList.add('hide-bottom-nosotros');
    } catch(e){}
  }
})();